import React, { useState, useEffect, useRef } from "react";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";

const SelectionLoadingStatus = ({ selectionDetails, selectionLoading }) => {
  const total = selectionDetails?.length || 0;
  const loadedCount = Object.values(selectionLoading || {}).filter(v => v === false).length;
  const isComplete = loadedCount === total;
  const progress = total > 0 ? (loadedCount / total) * 100 : 0;

  if (total === 0 || isComplete) return null;

  const activeSelection = selectionDetails.find(sel => selectionLoading?.[sel.selectionId] !== false);

  return (
    <div
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 9999,
        width: 260,
        backgroundColor: "#fff",
        borderRadius: 16,
        boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
        border: "1px solid #e2e8f0",
        overflow: "hidden",
      }}
    >
      {/* Progress bar */}
      <div style={{ height: 4, backgroundColor: "#f1f5f9" }}>
        <div
          style={{
            height: "100%",
            width: `${progress}%`,
            backgroundColor: "#3b82f6",
            transition: "width 0.3s ease",
          }}
        />
      </div>

      <div style={{ padding: "12px 14px" }}>
        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
          <HourglassTopIcon sx={{ fontSize: 16, color: "#3b82f6" }} className="animate-bounce" />
          <span style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Loadin Quote</span>
          <span style={{ marginLeft: "auto", fontSize: 12, fontWeight: 600, color: "#3b82f6" }}>
            {Math.round(progress)}%
          </span>
        </div>

        {/* Current item */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div
            style={{
              width: 14,
              height: 14,
              borderRadius: "50%",
              border: "2.5px solid #bfdbfe",
              borderTopColor: "#3b82f6",
              animation: "spin 0.8s linear infinite",
              flexShrink: 0,
            }}
          />
          <span style={{ fontSize: 11, color: "#64748b", truncate: true, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {activeSelection?.selectionName || "Finalizing..."}
          </span>
          <span style={{ marginLeft: "auto", fontSize: 11, color: "#94a3b8", flexShrink: 0 }}>
            {loadedCount}/{total}
          </span>
        </div>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default SelectionLoadingStatus;